export const mod = (n: number, m: number) => {
  return ((n % m) + m) % m;
};
